import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  float: right;
  padding-bottom: ${props => props.paddingBottom || 0};
  padding-top: ${props => props.paddingTop || 0};
`;

export const Container = styled.div`
  padding: 16px;
`;

export const ErrorMessage = styled.div`
  color: red;
  display: ${props => (props.visible ? 'block' : 'none')};
  z-index: 2;
`;



// WEBPACK FOOTER //
// ./app/components/PublishingDialog/styled-components.js